import { render, staticRenderFns } from "./ExhibitionViewList.vue?vue&type=template&id=350b4be2&"
import script from "./ExhibitionViewList.vue?vue&type=script&lang=js&"
export * from "./ExhibitionViewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabsItems})
